/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {TombOfNefertitiServerDataParser} from "../TombOfNefertitiServerDataParser";
import {ITombOfNefertitiGameData} from "./ITombOfNefertitiServerData";
import {TombOfNefertitiGameMode} from "../../gamemode/TombOfNefertitiGameMode";

export class TombOfNefertitiParsedGameData extends SpinParsedGameData {
    get curseSymbol(): string {
        return this._curseSymbol;
    }
    private readonly _respinPositionsAfter: boolean[];
    private readonly _payoutMultiplierNext: number;
    private readonly _isCurseFeatureTriggered: boolean;
    private readonly _isCurseFeatureReSpinTriggered: boolean;
    private readonly _isWildRaidFeatureTriggered: boolean;
    private readonly _wildRaidPositions: number[];
    private readonly _respinPlayed: number;
    private readonly _isRespinTriggered: boolean;
    private readonly _currentGameMode: string;
    private readonly _nextGameMode: string;
    private readonly _totalRespinWin: number;
    private readonly _curseSymbol: string;

    constructor(rawData: ITombOfNefertitiGameData, dataParser: TombOfNefertitiServerDataParser) {
        super(rawData, dataParser);

        this._respinPositionsAfter = dataParser.parseRespinPositionsAfter(rawData);
        this._payoutMultiplierNext = dataParser.parseNextMultiplier(rawData);
        this._isCurseFeatureTriggered = dataParser.parseCurseFeatureTriggered(rawData);
        this._isCurseFeatureReSpinTriggered = dataParser.parseCurseFeatureReSpinTriggered(rawData);
        this._isWildRaidFeatureTriggered = dataParser.parseWildRaidFeatureTriggered(rawData);
        this._wildRaidPositions = dataParser.parseWildRaidPositions(rawData);

        this._respinPlayed = dataParser.parseRespinPlayed(rawData);
        this._isRespinTriggered = dataParser.parseRespinTriggeredThisSpin(rawData);
        this._currentGameMode = dataParser.parseCurrentGameMode(rawData);
        this._nextGameMode = dataParser.parseNextGameMode(rawData);
        this._totalRespinWin = dataParser.parseTotalRespinWin(rawData);

        this._indexesForAttention = dataParser.parseIndexesForAttention(rawData);
        this._indexBeforeAttention = dataParser.parseIndexBeforeAttention(rawData);

        this._curseSymbol = rawData.curseSymbol
    }

    get totalRespinWin(): number {
        return this._totalRespinWin;
    }

    private _indexBeforeAttention: number;

    get indexBeforeAttention(): number {
        return this._indexBeforeAttention;
    }

    private _indexesForAttention: number[];

    get indexesForAttention(): number[] {
        return this._indexesForAttention;
    }

    get nextGameMode(): string {
        return this._nextGameMode;
    }

    get currentGameMode(): string {
        return this._currentGameMode;
    }

    get isRespinTriggered(): boolean {
        return this._isRespinTriggered;
    }

    get respinPlayed(): number {
        return this._respinPlayed;
    }

    public get respinPositions(): boolean[] {
        return this._respinPositionsAfter;
    }

    get isWildRaidFeatureTriggered(): boolean {
        return this._isWildRaidFeatureTriggered;
    }

    get wildRaidPositions(): number[] {
        return this._wildRaidPositions;
    }

    public get payoutMultiplierNext(): number {
        return this._payoutMultiplierNext;
    }

    get isCurseFeatureTriggered(): boolean {
        return this._isCurseFeatureTriggered;
    }

    get isCurseFeatureReSpinTriggered(): boolean {
        return this._isCurseFeatureReSpinTriggered;
    }

    protected isFeatureTotalWin(): boolean {
        return (this.mode === TombOfNefertitiGameMode.RESPIN || this.mode === TombOfNefertitiGameMode.RESPIN_FREESPIN);
    }

    protected isNextFeatureTotalWin(): boolean {
        return (this.nextMode === TombOfNefertitiGameMode.RESPIN || this.nextMode === TombOfNefertitiGameMode.RESPIN_FREESPIN);
    }
}